<!-- App footer. Needs to be in vue component to be included correctly -->
<template>
	<footer id="footer">
		<div class="container">
			<div class="row" id="footerLinks">
				<div class="col-sm-4">
					<h4>Services</h4>
						<a href="/utopia">UTOPIA Fiber</a><br>
						<a href="/cloud_hosting">Managed Hosting</a><br>
						<a href="/web_hosting">Shared Hosting</a><br>
						<a href="/colocation">Colocation</a><br>
						<a href="/email_collaboration">Email</a><br>
						<a href="/business_phone">Phone / VoIP</a>
				</div>
				<div class="col-sm-4">
					<h4>Credentials</h4>
						<a href="/green/">100% Green Powered<br>
						</a><a href="/soc2/">SOC 2</a><br>
						<a href="/pci/">PCI DSS<br>
						</a><a href="http://www.bbb.org/utah/business-reviews/internet-services/xmission-in-salt-lake-city-ut-2001636">BBB Accredited</a><br>
						<a href="/privacy-pledge/">Privacy Pledge</a><br>
						<a href="/environment/">Energy Star Certified</a>
				</div>
				<div class="col-sm-4">
					<h4>Social</h4>
          <i class="bi bi-bluesky"></i> <a href="https://bsky.app/profile/xmission.com">@xmission</a><br />
          <i class="bi bi-bluesky"></i> <a href="https://bsky.app/profile/status.xmission.com">@xmissionstatus</a><br />
          <i class="bi bi-facebook"></i> <a href="https://www.facebook.com/pages/XMission/6155383019">facebook</a><br>
          <i class="bi bi-instagram"></i> <a href="https://www.instagram.com/xmission/">instagram</a><br>
          <i class="bi bi-linkedin"></i> <a href="https://www.linkedin.com/company/33375?trk=NUS_CMPY_TWIT">linkedin</a><br>
          <i class="bi bi-star-fill"></i> <a href="/reviews">Review us</a>
				</div>
			</div>
			<br>
			<span class="copyright">©<span id="xmyear">{{ currentYear }}</span> XMission</span>
			<div class="custom-control custom-switch" id="modeBox">
				<input type="checkbox" class="custom-control-input" id="modeSwitch" v-on:click="darkmodeToggle">
				<label class="custom-control-label" for="modeSwitch" id="modeSwitchLabel">Dark mode</label>
			</div>
		</div>
	</footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	mounted () {
    this.setButtonToggle()
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
    ...mapGetters([
      'hasDarkTheme'
    ])
  },
	methods: {
		setButtonToggle () {
      if (this.hasDarkTheme){
        $("#modeSwitch").prop('checked', true);
        $("#modeSwitchLabel").html("Dark mode");
      }
      else {
        $("#modeSwitch").prop('checked', false);
        $("#modeSwitchLabel").html("Light mode");
      }
    },

    darkmodeToggle () {
      if($("#modeSwitch").prop('checked') === true){
        this.$store.dispatch('setDarkTheme');
        $("#modeSwitchLabel").html("Dark mode");
      } else {
        this.$store.dispatch('setLightTheme');
        $("#modeSwitchLabel").html("Light mode");
      }
    }
	}
}
</script>

<style scoped>

/* the mode toggle switch */

#modeBox input {
  opacity: 0;
  width: 0;
  height: 0;
}

#modeBox .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

#modeBox .slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

#modeBox input:checked + .slider {
  background-color: #2196F3;
}

#modeBox input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

#modeBox input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

#modeBox .slider.round {
  border-radius: 17px;
}

#modeBox .slider.round:before {
  border-radius: 50%;
}


#footer {font-size:14px}

#footerLinks {
  font-size:13px;
  margin-bottom:10px;
  color:#aaa;
  line-height:22px;
}

.copyright {font-size:11px; opacity:0.66}

#modeBox {padding-top:12px;}
#modeBox label {opacity:0.7}
.opacity-50 {opacity:0.5}

footer {
  margin-top:60px;
  padding:20px 0
}

footer h4 {
  margin-top:20px;
  font-size:11px;
  text-transform:uppercase;
  color:#666;
  margin-bottom:0;
  padding-bottom:8px;
}

footer {background:#eee}
#footer .fab {opacity:0.5}
.liteMode footer a {color:#888}
.darkMode footer {background:#1C1F22;}

.darkMode footer a {color:#bbb}

.bi-bluesky::before {
    content: "";
    background-color: currentColor;
    -webkit-mask: url("https://asset.xmission.com/logos/bluesky.svg") no-repeat 50% 50%;
    mask: url("https://asset.xmission.com/logos/bluesky.svg") no-repeat 50% 50%;
    -webkit-mask-size: cover;
    mask-size: cover;
    height: 12px;
    width: 12px;
}

</style>



// WEBPACK FOOTER //
// Foot.vue?9a78f8ec